import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import {
  Button, Col, Label, Modal, Row, UncontrolledTooltip
} from 'reactstrap';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import BootstrapTable from 'react-bootstrap-table-next';
import DropZone from 'react-dropzone';
import fileSaver from 'file-saver';
import { ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import moment from 'moment';
import Services from './services';
import Loader from '../../../commons/loader';
import DataEmptyState from '../../../commons/dataemptystate';
import NetworkEmptyState from '../../../commons/networkemptystate';
import EditorEmail from './EditorEmail';
import { FileCard } from '../../../commons/controls';
import Lib from '../../../commons/lib';
import RFField from '../../../components/Form/RFField';
import RFForm from '../../../components/Form/RFForm';
import SelectField from '../../../components/Form/SelectField';
import TimeFormatter from '../../../commons/TimeFormatter';
import ProgressButton from '../../../commons/ProgressButton';

const EmailContent = (props) => {
  const { globals } = props;

  const EDITOR_INIT = '';

  const [tableStatus, setTableStatus] = useState('TABL'); // ['LOAD', 'DATA', 'NETW', 'TABL']
  const [emailSablonJSON, setEmailSablonList] = useState([]);
  const [emailSablonModal, setEmailSablonModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  const [edit, setEdit] = useState(false);
  const [sablonId, setSablonId] = useState(null);
  const [cegadatOptions, setCegadatOptions] = useState([]);
  const [cegadat, setCegadat] = useState(null);
  const [tipusOptions, setTipusOptions] = useState([]);
  const [tipus, setTipus] = useState(null);
  const [logo, setLogo] = useState(null);
  const [subject, setSubject] = useState(null);
  const [text, setText] = useState(EDITOR_INIT);

  const [saveButtonLoading, setSaveButtonLoading] = useState(false);
  const [deleteButtonLoading, setDeleteButtonLoading] = useState(false);
  const [modifyButtonLoading, setModifyButtonLoading] = useState(false);

  const selectStyles = {
    control: base => ({
      ...base,
      '&:focus': { borderColor: 'red' }, // border style on hover
      border: '1px solid lightgray', // default border color
      boxShadow: 'none', // no box-shadow
      borderRadius: '0'
    }),
  };

  const getEmailSablonList = async () => {
    setTableStatus('LOAD');
    try {
      const json = await Services.listEmailSablon();
      if (!json.length) {
        setTableStatus('DATA');
      } else {
        setEmailSablonList(json);
        setTableStatus('TABL');
      }
    } catch (ex) {
      setTableStatus('NETW');
    }
  };

  const getEmailSablonTipusList = async () => {
    try {
      const json = await Services.listEmailSablonTipus();
      let array = [];
      json.forEach((sablontipus) => {
        array.push(<option value={sablontipus.name}>{sablontipus.caption}</option>);
      });
      setTipusOptions(array);
    } catch(e) {}
  };

  useEffect(() => {
    getEmailSablonList();
    getEmailSablonTipusList();
  }, []);

  const handleEditClick = async (id) => {
    setModifyButtonLoading(true);
    try {
      const res = await Services.getEmailSablon({ id });
      setEdit(true);
      setSablonId(res.id);
      setCegadatOptions([]);
      setCegadat(res.cegadat);
      setTipus(res.tipus && res.tipus.name);
      setLogo(res.object);
      setSubject(res.targy);
      setText(res.szoveg);
      setEmailSablonModal(true);
    } catch (ex) { }
    setModifyButtonLoading(false);
  };

  const handleDeleteClick = (id) => {
    setSablonId(id);
    setDeleteModal(true);
  };

  const deleteClick = async () => {
    setDeleteButtonLoading(true);
    try {
      await Services.deleteEmailSablon({ id: sablonId });
      getEmailSablonList();
      setDeleteModal(false);
    } catch (ex) { }
    setDeleteButtonLoading(false);
  };

  const handleNewSablonClick = () => {
    setEdit(false);
    setSablonId(null);
    setCegadatOptions([]);
    setCegadat(null);
    setTipus(null);
    setLogo(null);
    setSubject(null);
    setText(EDITOR_INIT);
    setEmailSablonModal(true);
  };

  const saveEmailSablon = async () => {
    let submitObjParam;
    if (logo) {
      submitObjParam = JSON.parse(JSON.stringify(logo));
      if (submitObjParam.new) {
        delete submitObjParam.id;
      }
    }
    try {
      const obj = {
        id: sablonId,
        cegadat: cegadat,
        tipus: tipus,
        object: submitObjParam,
        targy: subject,
        szoveg: text
      };
      setSaveButtonLoading(true);
      if (!edit) await Services.addEmailSablon(obj);
      else await Services.editEmailSablon(obj);
      setSaveButtonLoading(false);
      setEmailSablonModal(false);
      getEmailSablonList();
      globals.addSuccess('Email sablon rögzítve!');
    } catch (ex) { }
  };

  const loadCegadatOptions = (input, callback) => {
    if (_.isEmpty(input)) return;
    Services.listCegadat({}, (err, res) => {
      if (!err) {
        const optionsCegadat = res[0].filter(k => k.nev.toLowerCase().includes(input.toLowerCase()));
        if (optionsCegadat.length == 1) setCegadat(optionsCegadat[0]);
        setCegadatOptions(optionsCegadat);
      }
    });
  };

  const onDropObject = (acceptedfiles) => {
    acceptedfiles.forEach((file) => {
      const reader = new FileReader();
      reader.onload = () => {
        const fileAsBinaryString = reader.result;
        setLogo({
          content: btoa(fileAsBinaryString),
          uploadDate: new Date(),
          docname: file.name,
          preview: file.preview,
          logo: true,
          mime: file.type || 'application/octet-stream',
          new: true,
          length: file.size,
          id: Lib.Browser.uuidv4()
        });
      };
      reader.readAsBinaryString(file);
    });
  };

  const getContent = async () => {
    try {
      const res = await Services.downloadObject({ id: logo.id });
      fileSaver.saveAs(new Blob([res], { type: logo.mime }), logo.docname);
    } catch (ex) { }
  };

  const downloadObject = (e) => {
    e.preventDefault();
    if (logo.preview) {
      window.open(logo.preview, '_blank');
    } else {
      getContent();
    }
  };

  const removeObject = () => {
    setLogo(null);
  };

  const formatBytes = (bytes) => {
    if (bytes < 1024) return bytes + ' bájt';
    if (bytes < 1048576) return (bytes / 1024).toFixed(3) + ' KB';
    if (bytes < 1073741824) return (bytes / 1048576).toFixed(3) + ' MB';
    return (bytes / 1073741824).toFixed(3) + ' GB';
  };

  const tableIconFormatter = (cell, row) => {
    return (
      <>
        <React.Fragment>
          <ProgressButton
            className="icon-pencil table-action-icon"
            id={'action-view-' + cell + 'modositas'}
            loading={modifyButtonLoading}
            onClick={() => handleEditClick(cell)}
            type="button"
          />
          <UncontrolledTooltip trigger='hover focus-visible'
            style={{ float: 'left' }}
            placement="top"
            target={'action-view-' + cell + 'modositas'}
            delay={50}
          >
            {'Módosítás'}
          </UncontrolledTooltip>
          <Button
            className="icon-trash table-action-icon"
            id={'action-view-' + cell + 'file'}
            onClick={() => handleDeleteClick(cell)}
            type="button"
          />
          <UncontrolledTooltip trigger='hover focus-visible'
            style={{ float: 'left' }}
            placement="top"
            target={'action-view-' + cell + 'file'}
            delay={50}
          >
            {'Törlés'}
          </UncontrolledTooltip>
        </React.Fragment>
      </>
    );
  };

  const renderEmailSablonTable = () => {
    const columns = [
      {
        dataField: 'tipus',
        text: 'Típus',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        formatter: cell => cell && cell.caption,
        filterValue: cell => cell && cell.caption,
        style: {
          whiteSpace: 'pre-line',
        },
        sort: true,
      },
      {
        dataField: 'cegadat',
        text: 'Cégadat',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        formatter: cell => cell && cell.teljesnev,
        filterValue: cell => cell && cell.teljesnev,
        style: {
          whiteSpace: 'pre-line',
        },
        sort: true,
      },
      {
        dataField: 'modidopont',
        text: 'Módosítás időpontja',
        style: {
          whiteSpace: 'pre-line',
        },
        sort: true,
        formatter: cell => cell && TimeFormatter.formatDateTimeWithoutSeconds(cell),
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        hidden: !globals.hasRole(['RENDELES_EMAILSABLON'], true),
        formatter: tableIconFormatter,
      },
    ];
    return (
      <BootstrapTable bootstrap4 keyField="id" data={emailSablonJSON} columns={columns} filter={filterFactory()} />
    );
  };

  const renderModals = () => {
    return (
      <>
        <Modal
          isOpen={emailSablonModal}
          toggle={() => setEmailSablonModal(!emailSablonModal)}
          backdrop="static"
          size="lg"
        >
          <RFForm
            onSubmit={saveEmailSablon}
          >
            <ModalHeader>
          Email sablon
              {' '}
              {sablonId ? 'módosítása' : 'felvétele'}
            </ModalHeader>
            <ModalBody>

              <Row>
                <Col md="6">
                  <SelectField
                    label='Cégadat:'
                    name="cegadat"
                    id="cegadat"
                    placeholder="Kezdj el gépelni a kereséshez..."
                    loadingMessage={() => 'Keresés...'}
                    noOptionsMessage={() => 'Nincs keresési eredmény'}
                    onChange={v => setCegadat(v || {})}
                    onInputChange={_.debounce(loadCegadatOptions, 1000)}
                    value={cegadat || null}
                    options={cegadatOptions}
                    getOptionLabel={option => option.nev || option.teljesnev}
                    getOptionValue={option => option.id}
                    isDisabled={sablonId}
                    isClearable
                    required
                  />
                </Col>
                <Col md="6">
                  <RFField
                    label={'Típus:'}
                    id="tipus"
                    name="tipus"
                    type="select"
                    value={tipus}
                    onChange={(e, v) => setTipus(v)}
                    defaultSelect={<option value="" disabled>Válassz típust...</option>}
                    selectOptions={tipusOptions}
                    disabled={sablonId}
                  />
                </Col>
                <Col md="6">
                  <h5 style={{ marginBottom: 20, marginTop: 10 }}>Logó feltöltése:</h5>
                </Col>
              </Row>
              <Row>
                {!logo && (
                <Col md="12">
                  <DropZone
                    onDrop={onDropObject}
                    className="custom-dropzone"
                  >
                    {({getRootProps, getInputProps}) => (
                      <div {...getRootProps({ className: 'custom-dropzone'})}>
                        <input {...getInputProps()} />
                        <div className="dropzone-text">
                          {'Kép feltöltése!'}
                        </div>
                      </div>
                    )}
                  </DropZone>
                </Col>
                )}
                <Col md="12">
                  {logo && (
                  <div className="col-md-4" key="logo">
                    <FileCard
                      key="logo"
                      mime={logo.mime}
                      title={logo.docname}
                      length={formatBytes(logo.length)}
                      activeLogo={logo.logo}
                      onDownloadClick={downloadObject}
                      onDeleteClick={removeObject}
                    />
                  </div>
                  )}
                </Col>
                <Col md="12" className="mb-1">
                  <RFField
                    label={'Tárgy: '}
                    name="subject"
                    id="subject"
                    value={subject}
                    onChange={(e, v) => setSubject(v)}
                  />
                </Col>
                <Col md="12">
                  <EditorEmail
                    text={text}
                    setText={setText}
                  />
                </Col>
              </Row>

            </ModalBody>
            <ModalFooter>
              <ProgressButton loading={saveButtonLoading} type="submit" color="success">Mentés</ProgressButton>
              <Button type="button" onClick={() => setEmailSablonModal(false)}>Mégsem</Button>
            </ModalFooter>
          </RFForm>
        </Modal>
        <Modal
          isOpen={deleteModal}
          toggle={() => {
            setDeleteModal(false);
          }}
          backdrop="static"
        >
          <ModalHeader>Sablon törlése</ModalHeader>
          <ModalBody>Biztosan törölni szeretnéd a sablont?</ModalBody>
          <ModalFooter>
            <ProgressButton loading={deleteButtonLoading} color="primary" onClick={deleteClick}>Igen</ProgressButton>
            <Button onClick={() => {
              setDeleteModal(false);
            }}
            >
          Mégsem
            </Button>
          </ModalFooter>
        </Modal>
      </>
    );
  };

  return (
    <div className="row">
      <div className="col-md-12">
        {globals.hasRole(['RENDELES_EMAILSABLON'], true) && (
          <div className="mb-1">
            <Button color="primary" onClick={handleNewSablonClick}>Új sablon</Button>
          </div>
        )}
        {
          {
            LOAD: <Loader />,
            DATA: <DataEmptyState hasImage subtitle="Vigyél fel új tételt!" />,
            NETW: (
              <NetworkEmptyState
                hasImage
                submitClick={getEmailSablonList}
              />
            ),
            TABL: renderEmailSablonTable(),
          }[tableStatus]
        }
        {renderModals()}
      </div>
    </div>
  );
};

export default EmailContent;
